<div class="modal-advanced-search">
    <div class="mdl-header d-flex align-items-center justify-content-between">
        <div>
            <h6>Change Card Status</h6>
            <p class="mdl-header-text">Enter your details to proceed further</p>
        </div>
        <div class="close-mdl">
            <mat-icon fontIcon="close" (click)="dialogRef.close()" />
        </div>
    </div>
    <div class="mdl-body">
        <div class="field d-flex flex-row align-items-center">
            <p class="w-40 field-label">Card</p>
            <div class="w-60 field-value">
                <img
                    *ngIf="(cardItem.bin && cardItem.bin.startsWith('1', 1)) || isRiyadTenant"
                    [ngSrc]="'assets/mastercard.svg'"
                    alt="master img"
                    class="me-2"
                    height="16"
                    width="28"
                />
                <img
                    *ngIf="cardItem.bin && !cardItem.bin.startsWith('1', 1) && !isRiyadTenant"
                    [ngSrc]="'assets/visacard.svg'"
                    alt="visa img"
                    class="me-2"
                    height="12"
                    width="33"
                /><span class="fs-6">•••• {{ cardItem.last_four }}</span>
            </div>
        </div>
        <div class="field d-flex flex-row align-items-center">
            <p class="w-40 field-label">Card Status</p>
            <div class="w-60 field-value" (click)="openCardStatusModal()">
                <app-status [status]="newSelectStatus || cardItem?.status" [isDropdown]="true" />
            </div>
        </div>
        
        <div class="field d-flex flex-row">
            <p class="w-40 field-label">Comments</p>
            <div class="w-60 field-value">
                <app-value-field [editMode]="true">
                    <app-value-field-textarea
                        *ngIf="cardStatusForm.controls.comment"
                        [control]="cardStatusForm.controls.comment"
                        appValueField="editField"
                        controlDisplayName="Comments"
                        placeholder="Comments"
                    ></app-value-field-textarea>
                </app-value-field>
            </div>
        </div>
    </div>
    <div class="mdl-footer">
        <button mat-flat-button class="flat-btn" (click)="dialogRef.close()">Close</button>
        <button
            mat-raised-button
            class="save-btn"
            [disabled]="(!isRiyadTenant && cardStatusForm.invalid) || (!newSelectStatus && isRiyadTenant)"
            [class.button-spinner]="isLoading"
            (click)="onSubmit()"
        >
            {{ !isLoading ? 'Confirm' : '' }}
        </button>
    </div>
</div>
